namespace TabAurous.OMS {
    export interface ProductSizeMasterForm {
        CategoryId: Serenity.LookupEditor;
        CategoryName: Serenity.StringEditor;
        ProductSizeCode: Serenity.StringEditor;
        SizeType: ProductSizeMasterEditor;
        MM: Serenity.DecimalEditor;
        CM: Serenity.DecimalEditor;
        INCH: Serenity.DecimalEditor;
    }

    export class ProductSizeMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductSizeMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductSizeMasterForm.init)  {
                ProductSizeMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = ProductSizeMasterEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ProductSizeMasterForm, [
                    'CategoryId', w0,
                    'CategoryName', w1,
                    'ProductSizeCode', w1,
                    'SizeType', w2,
                    'MM', w3,
                    'CM', w3,
                    'INCH', w3
                ]);
            }
        }
    }
}
